import React, { useRef, useEffect, useState } from "react";
import { Box, Tab, Tabs, TabList, IconButton, HStack, VStack, Image, Text } from "@chakra-ui/react";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import Translate from "../../components/LanguageTranslation/Translate";

const CityTabs = ({ destinations, selectedCityIndex, setSelectedCityIndex, countryFlagLink }) => {
  const cityTabListRef = useRef(null);
  const [showCityLeftArrow, setShowCityLeftArrow] = useState(false);
  const [showCityRightArrow, setShowCityRightArrow] = useState(false);

  const checkCityTabScrollButtons = () => {
    if (cityTabListRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = cityTabListRef.current;
      setShowCityLeftArrow(scrollLeft > 1);
      setShowCityRightArrow(
        Math.ceil(scrollLeft + clientWidth) < scrollWidth - 1
      );
    }
  };

  useEffect(() => {
    const initialCheck = () => {
      checkCityTabScrollButtons();
      setTimeout(checkCityTabScrollButtons, 100);
      setTimeout(checkCityTabScrollButtons, 500);
      setTimeout(checkCityTabScrollButtons, 1000);
    };
    initialCheck();
    const tabListElement = cityTabListRef.current;
    const handleResize = () => {
      requestAnimationFrame(checkCityTabScrollButtons);
    };
    tabListElement?.addEventListener("scroll", checkCityTabScrollButtons);
    window.addEventListener("resize", handleResize);
    window.addEventListener("load", initialCheck);
    const observer = new MutationObserver(checkCityTabScrollButtons);
    if (tabListElement) {
      observer.observe(tabListElement, {
        childList: true,
        subtree: true,
        attributes: true,
      });
    }
    return () => {
      tabListElement?.removeEventListener("scroll", checkCityTabScrollButtons);
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("load", initialCheck);
      observer.disconnect();
    };
  }, [destinations, selectedCityIndex]);

  const cityTabScrollLeft = () => {
    if (cityTabListRef.current) {
      cityTabListRef.current.scrollBy({
        left: -300,
        behavior: "smooth",
      });
    }
  };
  const cityTabScrollRight = () => {
    if (cityTabListRef.current) {
      cityTabListRef.current.scrollBy({
        left: 300,
        behavior: "smooth",
      });
    }
  };

  if (!Array.isArray(destinations) || destinations.length <= 1) return null;

  return (
    <Tabs
      variant="unstyled"
      onChange={setSelectedCityIndex}
      index={selectedCityIndex}
      mt={1}
    >
      <Box position="relative" w="100%">
        {showCityLeftArrow && (
          <IconButton
            aria-label="Scroll Left"
            icon={<ChevronLeftIcon />}
            onClick={cityTabScrollLeft}
            isRound={true}
            size="xs"
            position="absolute"
            top="40%"
            left="0px"
            transform="translateY(-50%)"
            backgroundColor="white"
            boxShadow="base"
            zIndex="overlay"
          />
        )}
        <TabList
          ref={cityTabListRef}
          overflowX="auto"
          position="relative"
          sx={{
            "&::-webkit-scrollbar": {
              display: "none",
            },
            msOverflowStyle: "none",
            scrollbarWidth: "none",
          }}
        >
          {destinations.map((dest, idx) => (
            <Tab
              key={idx}
              _selected={{
                bg: "rgb(222, 241, 222)",
                border: "2px solid #286328",
                boxShadow: "lg",
                zIndex: 1,
              }}
              _hover={{
                bg: "rgb(231, 250, 231)",
                boxShadow: "md",
                transform: "scale(1.03)",
              }}
              p={2}
              border="2px solid"
              borderColor="gray.200"
              borderRadius="2xl"
              mr={3}
              minW="140px"
              maxW="180px"
              minH="60px"
              display="flex"
              alignItems="center"
              justifyContent="flex-start"
              transition="all 0.15s"
              overflow="hidden"
            >
              <Image
                src={countryFlagLink(dest.country)}
                alt={dest.country}
                boxSize="32px"
                borderRadius="full"
                mr={3}
                flexShrink={0}
                boxShadow="sm"
              />
              <VStack spacing={0} minW="0" maxW="100%" align="flex-start">
                <Text fontWeight="bold" fontSize="md" mb={0} maxW="100%">
                  <Translate text={dest.city} />
                </Text>
                <Text
                  isTruncated
                  fontWeight="bold"
                  fontSize="xs"
                  color="gray.500"
                  mb={0}
                  maxW="100%"
                >
                  <Translate text={dest.country} />
                </Text>
              </VStack>
            </Tab>
          ))}
        </TabList>
        {showCityRightArrow && (
          <IconButton
            aria-label="Scroll Right"
            icon={<ChevronRightIcon />}
            onClick={cityTabScrollRight}
            isRound={true}
            size="xs"
            position="absolute"
            top="40%"
            right="0px"
            transform="translateY(-50%)"
            backgroundColor="white"
            boxShadow="base"
            zIndex="overlay"
          />
        )}
      </Box>
    </Tabs>
  );
};

export default CityTabs; 